
import {css} from 'lit';
// eslint-disable-next-line import/prefer-default-export
export const style = css`/**
 * @tokens Hidden
 */
/* @presenter FontWeight */
/* @presenter FontWeight */
/* @presenter FontWeight */
/* @presenter FontWeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/**
 * Padding Sizes
 */
/**
 * Border Radiuses
 */
/**
 * @tokens Hidden
 */
/**
 * @tokens Padding Sizes
 * @presenter Spacing
 */
/**
 * @tokens Border Radiuses
 * @presenter BorderRadius
 */
/**
 * @tokens Hidden
 */
/**
 * Border / offset sizes
 */
@keyframes sidebar-expand {
  from {
    opacity: 0;
    transform: translateX(-24px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}
:host {
  z-index: 10000;
  position: fixed;
}
:host .sidebar-holder {
  font-family: var(--slh-default-font-family, "Open Sans");
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  width: auto;
  height: calc(100vh - 56px - 16px - 16px);
  position: relative;
  background-color: var(--slh-color-neutral-shade-00, #FFFFFF);
  padding: 16px 4px 16px 4px;
  filter: drop-shadow(0px 8px 24px var(--slh-color-neutral-shade-80-opacity-12, rgba(78, 94, 126, 0.16)));
  -webkit-filter: drop-shadow(0px 8px 24px var(--slh-color-neutral-shade-80-opacity-12, rgba(78, 94, 126, 0.16)));
}
:host .sidebar-holder .sidebar-top {
  display: flex;
  width: 100%;
  flex-direction: column;
  align-self: flex-start;
  flex-shrink: 0;
  padding: 0 8px;
  box-sizing: border-box;
}
:host .sidebar-holder .sidebar-items-holder {
  display: flex;
  flex-direction: column;
  width: 100%;
  overflow-y: auto;
  box-sizing: border-box;
  padding: 0 4px;
}
:host .sidebar-holder .sidebar-items-holder.hidden {
  display: none;
}
:host .sidebar-holder .sidebar-items-holder .sidebar-item-holder {
  display: flex;
  flex-direction: column;
  position: relative;
}
:host .sidebar-holder .sidebar-icon {
  height: 40px;
  width: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
}
:host .sidebar-holder.collapsed .sidebar-top .sidebar-icon,
:host .sidebar-holder.collapsed .sidebar-top .sidebar-home-link {
  display: none;
}
:host .sidebar-holder.expanded {
  width: 260px;
  height: calc(100vh - 16px - 16px);
  padding: 8px 0 24px 0;
  position: fixed;
  top: 0;
  left: 0;
  animation: sidebar-expand 220ms ease-out both;
}
:host .sidebar-holder.expanded .sidebar-top {
  flex-direction: row;
  width: 100%;
  margin-bottom: 40px;
}
:host .sidebar-holder.expanded .sidebar-top .item-skeleton {
  width: 100%;
  margin-left: 8px;
}
:host .sidebar-holder.expanded .sidebar-top .sidebar-icon {
  flex-shrink: 0;
  display: flex;
  fill: var(--slh-color-neutral-shade-60, #62779F);
  cursor: pointer;
}
:host .sidebar-holder.expanded .sidebar-top .sidebar-icon:hover {
  fill: var(--slh-color-neutral-shade-80, #4E5E7E);
}
:host .sidebar-holder.hidden {
  display: none;
}
:host .sidebar-holder a {
  outline-color: var(--slh-color-outline, #4C49D4);
}
@media (max-width: 560px) {
  :host .sidebar-holder {
    display: none;
  }
  :host .sidebar-holder.expanded {
    display: flex;
    width: 100%;
  }
}
`;
